import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@clerk/clerk-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  const { isSignedIn, isLoaded, getToken } = useAuth();

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      setLocation("/login");
      return;
    }

    // Test token validity on route access
    if (isLoaded && isSignedIn) {
      getToken().catch(() => {
        // If token fetch fails, likely session expired
        setLocation("/login");
      });
    }
  }, [isSignedIn, isLoaded, setLocation, getToken]);

  if (!isLoaded) {
    return <div>{t("components.protectedRoute.loading")}</div>;
  }

  if (!isSignedIn) {
    return null;
  }

  return <>{children}</>;
}
